<template>
    <div class="w-25 centered-layer position-fixed d-flex justify-content-center mt-2" style="z-index: 1000;">
        <div class="position-relative">
            <input class="form-control border border-2 border-primary" type="date" v-model="startDate" style="--bs-border-opacity: .5;" required>
        </div>
    </div>
</template>


<script>
export default {
    props: ['date'],
    mounted() {
        this.startDate = this.date;
    },
    data() {
        return {
            startDate: null,
        };
    },
    watch: {
        startDate: function (newValue) {
            this.$emit('updateDate', newValue);
        },
    },
}
</script>

<style>
.centered-layer {
    left: 50%;
    transform: translate(-50%, 0);
}
</style>